function Overview({ state }) {
    const planets = Object.keys(state.planets).map((key, index) => {
        return {... state.planets[key], id: key}
    })
    const totalResources = planets.reduce(
      (totals, planet) => {
        totals.metal += planet.resources.metal;
        totals.crystal += planet.resources.crystal;
        totals.deuterium += planet.resources.deuterium;
        return totals;
      },
      { metal: 0, crystal: 0, deuterium: 0 }
    );
  
    return (
      <section className="overview">
        <h2>Overview</h2>
        <p>Total Metal: {totalResources.metal}</p>
        <p>Total Crystal: {totalResources.crystal}</p>
        <p>Total Deuterium: {totalResources.deuterium}</p>
        <p>Total Time: {state.time}</p>
      </section>
    );
  }
  
  export default Overview;